import React from 'react';
import ReactDOM from 'react-dom';
import ErrorPage from './components/ErrorPage/ErrorPage';
import {
  getAccessToken,
  getBrandId,
  getBankId,
  getIsSME,
  getUserTrackingId,
  getTemplate
} from './parameter-parsing';
import { fetchConfig, fetchSAMLToken } from './api';
import {
  setEgainUriMetaValues,
  setEgainUriParams,
  getReferrerUrl,
  postToNativeApp
} from './egain-chat';

const startApp = async () => {
  try {
    const accessToken = getAccessToken();
    const bankId = getBankId();
    const brandId = getBrandId();
    const userTrackingId = getUserTrackingId();
    const isSme = getIsSME();
    const config = await fetchConfig();

    const samlToken = await fetchSAMLToken(accessToken, config, bankId, userTrackingId);

    // todo dept tells our chat init to post values to egain, not 100% on why as no docs
    const postChatAttributes = true;

    // Initialise eGain live agent chat
    const egainMetaValues = setEgainUriMetaValues(config, postChatAttributes, brandId, isSme);
    const egainChatUrl = setEgainUriParams(getReferrerUrl(), egainMetaValues);
    postToNativeApp(egainChatUrl, samlToken, postChatAttributes);
  } catch (error) {
    console.error(error);
    ReactDOM.render(<ErrorPage />, document.getElementById('root'));
  }
};

startApp();
